/**
 * Sticky header: top bar always sticky;
 * menu row hides on any scroll down, returns on any scroll up.
 * Lock covers the full height transition to prevent expand/collapse jitter.
 */
(function () {
  var DELTA_DOWN = 2;
  var DELTA_UP = 4;
  var MIN_SCROLL = 8;
  var TRANSITION_MS = 220;
  var LOCK_MS = 240;
  var lastY = 0;
  var lockedUntil = 0;
  /* A filter click can shrink the page or scroll the results up. That is not
     the shopper scrolling, so the compact menu stays put until they do. */
  var suppressExpand = false;
  var ticking = false;
  var touchHeader = window.matchMedia('(max-width: 989px)');
  var headerEl = null;
  var slotEl = null;
  var collapsed = false;
  var heightTimer = null;

  function qsHeader() {
    return document.querySelector('.header.header--ri');
  }

  function qsSlot(header) {
    return header && header.querySelector('.ri-header__nav-slot');
  }

  function topBarHeight(header) {
    var top = header && header.querySelector('.ri-header__top');
    return top ? top.offsetHeight : 0;
  }

  function setHeaderHeight(explicitPx) {
    if (typeof explicitPx === 'number' && !isNaN(explicitPx)) {
      document.documentElement.style.setProperty('--header-height', Math.max(0, explicitPx) + 'px');
      return;
    }
    var section = document.querySelector('.section-header');
    if (!section) return;
    /* Measure sticky header only — cart-notification lives in the section
       and must never inflate this (see ri-cart-notification.css). On a phone, the blue block, as the
       header's first-paint script and ri-mobile.js measure it: the outer box is 2px taller (its border), and
       with two answers the last one to run won, so on an iPhone the value could change on the first scroll. */
    var cluster = touchHeader.matches && section.querySelector('.ri-header__sticky-cluster');
    var sticky = cluster || section.querySelector('sticky-header') || section.querySelector('header');
    var height = sticky ? sticky.offsetHeight : section.offsetHeight;
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }

  function closeOpenMenus(header) {
    if (!header) return;
    header.querySelectorAll('header-menu > details[open]').forEach(function (details) {
      details.open = false;
    });
  }

  function isSearchOpen(header) {
    var predictive = header && header.querySelector('predictive-search');
    return predictive && predictive.isOpen;
  }

  function lock() {
    lockedUntil = Date.now() + LOCK_MS;
  }

  function syncScrollY() {
    lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
  }

  function navInnerHeight(slot) {
    var nav = slot && slot.querySelector('.ri-header__nav');
    if (!nav) return 0;
    /* An open menu panel hangs below the row and would count in scrollHeight, which drops the logo
       into the page. While one is open, measure the row itself. */
    if (nav.querySelector('header-menu > details[open]')) return nav.offsetHeight;
    return nav.scrollHeight;
  }

  function syncNavToSearch(header) {
    header = header || headerEl || qsHeader();
    if (!header) return;
    var searchForm =
      header.querySelector('.ri-header__top .ri-header-search__form') ||
      header.querySelector('.ri-header__top > .ri-header__search-wrap');
    var slot = slotEl || qsSlot(header);
    slotEl = slot || slotEl;
    var nav = slot && slot.querySelector('.ri-header__nav');
    var menu = header.querySelector('#HeaderMenu-List');
    if (!nav) return;

    if (window.matchMedia('(max-width: 749px)').matches) {
      nav.style.paddingLeft = '';
      nav.style.paddingRight = '';
      if (menu) {
        menu.style.paddingLeft = '';
        menu.style.paddingRight = '';
        menu.style.flexWrap = '';
      }
      header.style.setProperty('--ri-nav-h', '0px');
      return;
    }

    /* Drop the old centered submenu-reserve inset so the first chip can
       sit on the search field's left edge. */
    if (menu) {
      menu.style.paddingLeft = '';
      menu.style.paddingRight = '';
    }

    if (searchForm && slot && searchForm.offsetWidth > 0) {
      var formRect = searchForm.getBoundingClientRect();
      var slotRect = slot.getBoundingClientRect();
      var headerRect = header.getBoundingClientRect();
      var headerPadRight = parseFloat(window.getComputedStyle(header).paddingRight) || 0;
      var rightEdge = headerRect.right - headerPadRight;
      /* The row starts at the header's content edge, under the logo (the logo sits in the top bar only). */
      var headerPadLeft = parseFloat(window.getComputedStyle(header).paddingLeft) || 0;
      nav.style.paddingLeft = Math.max(0, headerRect.left + headerPadLeft - slotRect.left) + 'px';
      nav.style.paddingRight = Math.max(0, slotRect.right - rightEdge) + 'px';
    }

    if (menu && !menu.querySelector('header-menu > details[open]')) {
      menu.style.flexWrap = 'nowrap';
      void menu.offsetWidth;
      if (menu.scrollWidth > menu.clientWidth + 1) {
        menu.style.flexWrap = 'wrap';
      }
    }

    /* The logo is centered from this height. A font swap moves it a pixel
       or two. Leave the first measurement alone unless the row actually wraps. */
    var nextNavH = navInnerHeight(slot);
    var prevNavH = parseFloat(header.style.getPropertyValue('--ri-nav-h'));
    if (!prevNavH || Math.abs(nextNavH - prevNavH) > 16) {
      header.style.setProperty('--ri-nav-h', nextNavH + 'px');
    }
  }

  function afterTransition(cb) {
    if (heightTimer) window.clearTimeout(heightTimer);
    heightTimer = window.setTimeout(function () {
      heightTimer = null;
      cb();
    }, TRANSITION_MS);
  }

  function collapse(header) {
    if (!header || collapsed) return;
    if (isSearchOpen(header)) return;
    var slot = slotEl || qsSlot(header);
    slotEl = slot;
    if (!slot) return;

    closeOpenMenus(header);
    collapsed = true;
    header.classList.add("ri-header--nav-motion");

    syncNavToSearch(header);
    var from = navInnerHeight(slot);
    /* Publish target sticky offset immediately so facets/top can ease with the menu */
    setHeaderHeight(topBarHeight(header));
    slot.style.height = from + 'px';
    header.classList.add('ri-header--nav-collapsed');
    void slot.offsetHeight;
    slot.style.height = '0px';
    lock();

    afterTransition(function () {
      setHeaderHeight(topBarHeight(header));
      syncScrollY();
    });
  }

  function expand(header) {
    if (!header || !collapsed) return;
    var slot = slotEl || qsSlot(header);
    slotEl = slot;
    if (!slot) return;

    collapsed = false;
    header.classList.add("ri-header--nav-motion");
    header.classList.remove('ri-header--nav-collapsed');
    syncNavToSearch(header);

    slot.style.height = '0px';
    var to = navInnerHeight(slot);
    /* Target full height now — sticky top transitions up with the menu expand */
    setHeaderHeight(topBarHeight(header) + to);
    void slot.offsetHeight;
    slot.style.height = to + 'px';
    lock();

    afterTransition(function () {
      if (!collapsed) slot.style.height = '';
      setHeaderHeight();
      syncScrollY();
    });
  }

  function onScroll() {
    if (touchHeader.matches) {
      ticking = false;
      return;
    }
    var now = Date.now();
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var header = headerEl || qsHeader();
    headerEl = header;

    if (!header) {
      lastY = y;
      ticking = false;
      return;
    }

    slotEl = slotEl || qsSlot(header);
    if (!slotEl || window.getComputedStyle(slotEl).display === 'none') {
      if (collapsed) expand(header);
      lastY = y;
      ticking = false;
      return;
    }

    if (now < lockedUntil || suppressExpand) {
      lastY = y < 0 ? 0 : y;
      ticking = false;
      return;
    }

    var delta = y - lastY;

    /* A menu panel or the store panel is open: the row stays, so the panel does too (owner, 2026-10-22). Folding
       the row closed the panel on the smallest scroll, and the next click landed on the product that was under it. */
    var menuOpen = document.documentElement.classList.contains('hv4-menu-open');

    if (y <= MIN_SCROLL) {
      expand(header);
    } else if (delta > DELTA_DOWN && !menuOpen) {
      collapse(header);
    } else if (delta < -DELTA_UP) {
      expand(header);
    }

    lastY = y < 0 ? 0 : y;
    ticking = false;
  }

  function requestTick() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(onScroll);
  }

  function init() {
    headerEl = qsHeader();
    slotEl = qsSlot(headerEl);
    collapsed = !!(headerEl && headerEl.classList.contains('ri-header--nav-collapsed'));
    syncScrollY();
    function releaseSuppress() {
      if (!suppressExpand) return;
      suppressExpand = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (y <= MIN_SCROLL) {
        var header = headerEl || qsHeader();
        if (header) expand(header);
      }
    }
    window.addEventListener('ri:header-ignore-scroll-up', function () {
      suppressExpand = true;
      syncScrollY();
    });
    window.addEventListener('ri:header-release-scroll', function () {
      suppressExpand = false;
    });
    window.addEventListener('wheel', releaseSuppress, { passive: true });
    window.addEventListener('touchmove', releaseSuppress, { passive: true });
    window.addEventListener('keydown', function (event) {
      var key = event.key;
      if (
        key === 'ArrowUp' ||
        key === 'ArrowDown' ||
        key === 'PageUp' ||
        key === 'PageDown' ||
        key === 'Home' ||
        key === 'End' ||
        key === ' '
      ) {
        releaseSuppress();
      }
    });
    window.addEventListener('scroll', requestTick, { passive: true });
    window.addEventListener('resize', function () {
      slotEl = qsSlot(headerEl || qsHeader());
      if (slotEl && !collapsed) slotEl.style.height = '';
      syncNavToSearch(headerEl || qsHeader());
      setHeaderHeight();
    });
    syncNavToSearch(headerEl);
    setHeaderHeight();
    window.requestAnimationFrame(function () {
      syncNavToSearch(headerEl || qsHeader());
      setHeaderHeight();
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncNavToSearch(headerEl || qsHeader());
        setHeaderHeight();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
